interface PermissionDataScope {
	areaId?: string
	countryId?: string
	businessLine?: string
	businessLineId?: string
	customerId?: string
	orgUnitId?: string
}

export interface User {
	changePasswordAtNextLogin: boolean
	companyName?: null | string
	country?: null | string
	createdBy?: null | string
	createdOn?: null | string
	creationChannel: unknown
	creationProduct: unknown
	defaultBranding?: null | string
	defaultLocale?: null | string
	defaultTimezone?: number
	eMail?: null | string
	firstName?: null | string
	hasRoles: unknown
	id: string
	isActive: boolean
	isAnalyticsEnabled: boolean
	isBlocked: boolean
	isLockedOut: boolean
	isEmailVerified: boolean
	isInternal: boolean
	isInvited: boolean
	invitedOn: string | null
	invitationProduct: unknown
	invitationProducts?: unknown
	isMobileNumberVerified: boolean
	isPasswordChangeRequired: boolean
	isPushNotificationsEnabled: boolean
	isTermsApprovalRequired: boolean
	isTester: boolean
	jobTitle?: null | string
	lastLoginDate?: null | string
	lastName?: null | string
	mobileDeviceToken?: null | string
	mobileDeviceTokens: { token: string; updatedAt: string }[]
	mobileNumber?: null | string
	modifiedBy?: null | string
	modifiedOn?: null | string
	marketId?: null | string
	name?: null | string
	primaryOrganisationalUnit?: null | string
	region?: null | string
	subscriptions?: unknown
	username: string
	requestedCustomerNumber?: null | string
	user_id: string
	lastActivityDates?: unknown
	termsAcceptedOn?: Date | string
	termsAcceptedVersion?: string
	dataPrivacyAcknowledgedVersion?: string
	dataPrivacyAcknowledgedOn?: Date | string
	failedLogin: boolean
	twoFactorEnabled?: boolean
}

export enum PermissionType {
	Customer = "ROLE_PERMISSION_CARBON_BANK_CUSTOMER",
	SalesRepresentative = "ROLE_PERMISSION_CARBON_BANK_SALES_REPRESENTATIVE",
	MrvCoordinator = "ROLE_PERMISSION_CARBON_BANK_MRV_COORDINATOR",
	Admin = "ROLE_PERMISSION_CARBON_BANK_ADMIN",
	Developer = "ROLE_PERMISSION_CARBON_BANK_DEVELOPER",
	MrvAnnualAssurer = "ROLE_PERMISSION_CARBON_BANK_MRV_ANNUAL_ASSURER",
	MrvDepositAssurer = "ROLE_PERMISSION_CARBON_BANK_MRV_DEPOSIT_ASSURER",
}

export interface UserPermission {
	userId: string
	connector: string
	permissionType: PermissionType
	dataScope: PermissionDataScope
	expiryDate?: Date
}
